import React from 'react';
import { motion } from 'framer-motion';
import { Github, Linkedin, Twitter, Youtube, Mail, ExternalLink } from 'lucide-react';

const Hero = () => {
  const socialLinks = [
    { name: 'LinkedIn', href: 'https://www.linkedin.com/in/harsh-murjani/', icon: <Linkedin size={20} /> },
    { name: 'GitHub', href: 'https://github.com/hm05', icon: <Github size={20} /> },
    { name: 'Twitter/X', href: 'https://x.com/murjani_harsh/', icon: <Twitter size={20} /> },
    { name: 'YouTube', href: 'https://youtube.com/@Cyber-Verse', icon: <Youtube size={20} /> },
    { name: 'Email', href: 'mailto:harshmurjani5114@gmail.com', icon: <Mail size={20} /> }
  ];

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.15,
        delayChildren: 0.3
      }
    }
  };

  const itemVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: { 
      opacity: 1, 
      y: 0, 
      transition: { duration: 0.8, ease: [0.16, 1, 0.3, 1] } 
    }
  };

  return (
    <section id="home" className="min-h-screen flex items-center justify-center pt-20 px-6">
      <motion.div 
        className="max-w-4xl w-full text-center"
        variants={containerVariants}
        initial="hidden"
        animate="visible"
      >
        <motion.div variants={itemVariants} className="inline-block px-3 py-1 rounded-full bg-blue-50 dark:bg-blue-900/30 text-blue-600 dark:text-blue-400 text-sm font-medium mb-6">
          Available to join immediately
        </motion.div>
        
        <motion.h1 
          className="text-5xl md:text-8xl font-bold tracking-tight text-gray-900 dark:text-white mb-8 font-inter"
          variants={itemVariants}
        >
          Harsh Murjani
        </motion.h1>
        
        <motion.div variants={itemVariants}>
          <p className="text-xl md:text-3xl text-gray-500 dark:text-gray-400 mb-8 font-inter font-light leading-relaxed">
            Backend Engineer specializing in <span className="text-gray-900 dark:text-white font-medium">Cloud-native architectures</span> and <span className="text-gray-900 dark:text-white font-medium">Cybersecurity</span>.
          </p>
        </motion.div>

        <motion.div 
          className="flex flex-wrap justify-center gap-4 mb-16"
          variants={itemVariants}
        >
          <a href="#projects" className="btn-primary px-8 py-4 text-lg">
            View Projects
          </a>
          <a href="/resume" className="btn-secondary px-8 py-4 text-lg flex items-center gap-2">
            Read Resume <ExternalLink size={18} />
          </a>
        </motion.div>

        <motion.div 
          className="flex justify-center gap-8"
          variants={itemVariants}
        >
          {socialLinks.map((social) => (
            <motion.a
              key={social.name}
              href={social.href}
              target="_blank"
              rel="noopener noreferrer"
              className="text-gray-400 hover:text-black dark:hover:text-white transition-colors p-2"
              whileHover={{ y: -2 }}
              whileTap={{ scale: 0.95 }}
              title={social.name}
            >
              {social.icon}
            </motion.a>
          ))}
        </motion.div>

        {/* Minimal Scroll Indicator */}
        <motion.div
          className="absolute bottom-12 left-1/2 -translate-x-1/2"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 2, duration: 1 }}
        >
          <div className="flex flex-col items-center gap-2 text-gray-400">
            <span className="text-xs uppercase tracking-widest font-medium">Scroll</span>
            <motion.div
              className="w-px h-12 bg-gradient-to-b from-gray-300 dark:from-gray-700 to-transparent"
              animate={{ height: [0, 48, 0], opacity: [0, 1, 0] }}
              transition={{ duration: 2, repeat: Infinity, ease: "easeInOut" }}
            />
          </div>
        </motion.div>
      </motion.div>
    </section>
  );
};

export default Hero;
